import {X} from "lucide-react";
import  {FC, useEffect, useRef, useState} from "react";
import TicketShareForm from "./TicketShareForm.tsx";
import {shareEventTicket, ShareEventTicket} from "../api/share.ts";
import {AnimatePresence, motion} from "framer-motion";
import {createPortal} from "react-dom";

interface ShareEventTicketModalProps {
    visible: boolean;
    ticket: any;
    onClose: () => void;
    hideBackdropClose?: boolean;
}

const ShareEventTicketModal:FC<ShareEventTicketModalProps>  = ({
                                   visible, ticket,
                                   onClose,
                                                                   hideBackdropClose = false
                               }) => {

    const [requestMessage, setRequestMessage] = useState<string>("");
    const [requestStatus, setRequestStatus] = useState<string>("");

    // Close on ESC
    useEffect(() => {
        if (!visible) return;
        const onKey = (e: any) => {
            if (e.key === "Escape") onClose?.();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [visible, onClose]);

    // Prevent scroll on body when open
    useEffect(() => {
        if (!visible) return;
        const original = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = original;
        };
    }, [visible]);

    const contentRef = useRef(null);

    // Close when clicking backdrop (optional)
    const handleBackdropClick = (e: any) => {
        if (hideBackdropClose) return;
        if (e.target === e.currentTarget) onClose?.();
    };

    const submitShareTicket = async (values: any, formik: any) => {
        const data: ShareEventTicket = {
            phoneNumber: values.phoneNumber,
            firstName: values.firstName,
            lastName: values.lastName,
            code: ticket?.code,
        };
        // Handle the ticket sharing logic here
        console.log("Ticket shared with values:", values);
        try {
            const response = await shareEventTicket(data);
            console.log("Share ticket response:", response);

            setRequestStatus((response as any)?.status ?? "success");
            setRequestMessage("Ticket partagé avec succès");
            formik?.setSubmitting(false);
        } catch (error) {
            const errorMessage =
                typeof error === "object" &&
                error !== null &&
                "response" in error &&
                (error as any).response?.data &&
                Array.isArray((error as any).response.data) &&
                (error as any).response.data[0]?.message
                    ? (error as any).response.data[0].message
                    : "Erreur lors du partage du ticket";

            setRequestMessage(errorMessage);
            setRequestStatus((error as any)?.status);
            formik?.setSubmitting(false);
        }
    };

    const modal = (
        <AnimatePresence>
            {visible && (
                <motion.div
                    className="fixed inset-0 z-[100] flex"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    {/* Transparent Backdrop */}
                    <div
                        className="absolute inset-0 backdrop-blur-xl"                        onMouseDown={handleBackdropClick}
                    />

                    {/* Panel */}
                    <motion.div
                        role="dialog"
                        aria-modal="true"
                        aria-label={""}
                        ref={contentRef}
                        className="relative ml-auto h-full w-full bg-white text-gray-900 dark:bg-zinc-900 dark:text-zinc-100 flex flex-col"                        initial={{ y: 16, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: 16, opacity: 0 }}
                        transition={{ type: "spring", stiffness: 260, damping: 24 }}
                    >

                        {/* Body */}
                        <div className="flex-1 flex items-center justify-center p-4 md:p-6 overflow-y-auto">
                            <div className=" w-full bg-white rounded-2xl  ">
                                div.
                                <button
                                    onClick={() => {
                                        console.log("setIsOpenShareModal")
                                        onClose()
                                    }}
                                    className="self-end text-gray-500 hover:text-gray-700 pt-2 px-4 "
                                >
                                    <X size={30}/>
                                </button>
                                <TicketShareForm
                                    onSubmit={submitShareTicket}
                                    response={requestMessage}
                                    requestStatus={requestStatus}
                                />
                            </div>

                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );

    return typeof window !== "undefined" ? createPortal(modal, document.body) : null;
    /*return  visible && (
        <div className="fixed  shadow-2xl inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white text-black rounded-none w-full h-full flex flex-col">
                <button
                    onClick={()=>{
                        console.log("setIsOpenShareModal")
                        onClose()
                    }}
                    className="absolute top-4 right-4 z-50  text-gray-500 hover:text-gray-700 pt-2 px-4 self-end"
                >
                    <X size={30}/>
                </button>
                <p className="mt-2 mb-2 mx-4">Partager le ticket</p>

                <TicketShareForm
                    onSubmit={submitShareTicket}
                    response={requestMessage}
                    requestStatus={requestStatus}
                />
            </div>
        </div>
    );*/
};

export default ShareEventTicketModal;
